import Axios from 'axios'
import {
	IConfirmTableModalData,
	IGetTableModalData,
	IGetTableModalPagination,
	ISelectAllTableModalData,
	ISelectTableModalData
} from 'models/TableModal'

const urlBase = '/lista_modal'

export const getTableModalData = async (params: IGetTableModalData) => {
	const response = await Axios.get(`${urlBase}/datos`, { params })
	return response.data
}

export const getTableModalPagination = async (
	params: IGetTableModalPagination
) => {
	const response = await Axios.get(`${urlBase}/paginar`, { params })
	return response.data
}

export const selectTableModalData = async (params: ISelectTableModalData) => {
	const response = await Axios.post(`${urlBase}/seleccionar`, params)
	return response.data
}

export const selectAllTableModalData = async (
	params: ISelectAllTableModalData
) => {
	const response = await Axios.post(`${urlBase}/seleccionar_todo`, params)
	return response.data
}

export const confirmTableModalData = async (params: IConfirmTableModalData) => {
	const response = await Axios.post(`${urlBase}/confirmar`, params)
	return response.data
}
